"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _selectGame = require("../../servers/selectGame");
require("./style.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @param {object} props 组件参数
 * @returns
 */
var SelectGame = function SelectGame(props) {
  // 参数获取
  var cash = props.cash,
    activation = props.activation,
    selectedGameOutFn = props.selectedGameOutFn,
    loadGameListOutFn = props.loadGameListOutFn;
  //游戏列表
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    gameList = _useState2[0],
    setGameList = _useState2[1];
  //获取游戏列表
  (0, _react.useEffect)(function () {
    var params = {
      cash: cash ? cash : '',
      activation: activation ? activation : ''
    };
    (0, _selectGame.getGameList)(params).then(function (res) {
      if (res && res.success) {
        var data = res.data;
        setGameList(data);
      } else {
        loadGameListOutFn(res);
      }
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "game_modify_first_wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "game_list"
  }, gameList.length > 0 ? gameList.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("a", {
      onClick: function onClick() {
        return selectedGameOutFn(item);
      },
      key: item.gameId
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: item.gameIcon ? item.gameIcon : '//img.gyyxcdn.cn/account/Content/images/account/gpic1.gif',
      id: item.gameId.toString(),
      alt: "\u6E38\u620Ficon"
    }));
  }) : /*#__PURE__*/_react.default.createElement("span", null, "\u6682\u65E0\u6570\u636E")));
};
var _default = SelectGame;
exports.default = _default;